import type { FunctionComponent } from 'react';

import { ThoughtMarker } from '~/ui/domain/chat/ThoughtMarker';

import { PRESENT_REASONING_TOOL_ID, type ReasoningResponseEvent } from '../../data-contract/chat';
import type { StructuredRenderer } from './types';

const ReasoningInline: FunctionComponent<{ readonly event: ReasoningResponseEvent }> = ({ event }) => {
    const { label, text } = event.payload;
    return (
        <ThoughtMarker label={label}>
            <p className="m-0 whitespace-pre-wrap text-[13px] text-black-900 [overflow-wrap:anywhere]">{text}</p>
        </ThoughtMarker>
    );
};

export const reasoningRenderer: StructuredRenderer<ReasoningResponseEvent> = {
    renderInline: (event) => <ReasoningInline event={event} />,
    toolId: PRESENT_REASONING_TOOL_ID,
};
